import _ from 'underscore';

const INT_CLIENT_ID = '726256105384-1qcidobv5pnoanufqnceta428ed2e48q.apps.googleusercontent.com';
const INT_CLIENT_ID_2 = '726256105384-1qcidobv5pnoanufqnceta428ed2e48q.apps.googleusercontent.com';

const PROD_CLIENT_ID = '1077476731478-rkm2njbbnpf033uq99f6gal9nf79jjen.apps.googleusercontent.com';
const PROD_CLIENT_ID_2 = '351642820379-qslit4brrmhbii77n7u8rdo0kuhd8i4n.apps.googleusercontent.com';

const appCount = 2;
const pilotCohort = (new Date()).getUTCMinutes() % appCount;

export const getGTMSessionType = useMultipleApps => (useMultipleApps && pilotCohort === 1 ? 'GTMImport2' : 'GTMImport');

export const getClientId = (domain, useMultipleApps) => {
  const prodApps = [PROD_CLIENT_ID, PROD_CLIENT_ID_2];
  const intApps = [INT_CLIENT_ID, INT_CLIENT_ID_2];

  const bingAdsProdPattern = /ui(.beta)?(.tip)?.bingads.microsoft.com$/;
  const msadProdPattern = /ui(.beta)?(.tip)?.ads.microsoft.com$/;

  if (
    _.isNull(domain.match(bingAdsProdPattern)) &&
    _.isNull(domain.match(msadProdPattern))
  ) {
    if (useMultipleApps) {
      return intApps[pilotCohort];
    }
    return INT_CLIENT_ID;
  }

  if (useMultipleApps) {
    return prodApps[pilotCohort];
  }
  return PROD_CLIENT_ID;
};
